export class ContactsJourneyEdge {
}
export var EdgeTypes;
(function (EdgeTypes) {
    EdgeTypes["Regular"] = "regular";
    EdgeTypes["Other"] = "other";
    EdgeTypes["End"] = "exit";
})(EdgeTypes || (EdgeTypes = {}));
export var EdgeOrder;
(function (EdgeOrder) {
    EdgeOrder[EdgeOrder["Top"] = 1] = "Top";
    EdgeOrder[EdgeOrder["Middle"] = 2] = "Middle";
    EdgeOrder[EdgeOrder["Bottom"] = 3] = "Bottom";
})(EdgeOrder || (EdgeOrder = {}));
